// extracted by mini-css-extract-plugin
export default {"tableRow":"styles_tableRow__nnJ54"};